import { render } from "./FlashSales.vue?vue&type=template&id=2a870c63&scoped=true"
import script from "./FlashSales.vue?vue&type=script&lang=js"
export * from "./FlashSales.vue?vue&type=script&lang=js"

import "./FlashSales.vue?vue&type=style&index=0&id=2a870c63&scoped=true&lang=css"
import "./FlashSales.vue?vue&type=style&index=1&id=2a870c63&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a870c63"]])

export default __exports__